import React, {useCallback, useEffect, useState} from "react";

import type {IAfterGuiAttachedParams, IDoesFilterPassParams} from "ag-grid-community";
import type {CustomFilterProps} from "ag-grid-react";
import {useGridFilter} from "ag-grid-react";
import {Button} from "react-bootstrap";
import {AdminUser} from "services/adminsService";
import {AvailableApp} from "services/loginServices";
import {AppNames} from "enums";

export const AdminAppLinksFilter = ({model, onModelChange, api}: CustomFilterProps) => {
    const [closeFilter, setCloseFilter] = useState<(() => void) | undefined>();
    const [selectedValues, setSelectedValues] = useState<string[] | null>(model);
    const [allAppIds, setAllAppIds] = useState<string[]>([]);

    const doesFilterPass = useCallback(
        (params: IDoesFilterPassParams<AdminUser>) => {
            const links = params.data?.appLinks;
            if (!links?.length) {
                return false;
            }
            const rowIds = new Set(links.map((al) => String(al.appId)));
            return (
                !!selectedValues &&
                selectedValues.some((id) => rowIds.has(id))
            );
        },
        [selectedValues],
    );

    const afterGuiAttached = useCallback(
        ({hidePopup}: IAfterGuiAttachedParams) => {
            setCloseFilter(() => hidePopup);
        },
        [],
    );

    useGridFilter({
        doesFilterPass,
        afterGuiAttached,
    });

    useEffect(() => {
        setSelectedValues(model ?? []);
    }, [model]);

    useEffect(() => {
        const ids = new Set<string>();
        api.forEachNode((node) => {
            node.data?.appLinks?.forEach((al: AvailableApp) =>
                ids.add(String(al.appId)),
            );
        });
        setAllAppIds([...ids]);
    }, [api]);

    const onClick = () => {
        closeFilter?.();
    };

    const sortedIds = [...allAppIds].sort((a, b) =>
        (AppNames[+a] ?? a).localeCompare(AppNames[+b] ?? b, undefined, {
            sensitivity: "base",
        }),
    );

    return (
        <div className="p-3 d-flex flex-column bg-white">
            <label className="fw-bold">Приложения</label>
            <div className="col-sm-10 mt-2">
                {sortedIds.map((id) => {
                    const label = AppNames[+id] ?? id;
                    return (
                        <div key={id} className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`admin-app-${id}`}
                                checked={selectedValues?.includes(id)}
                                onChange={() => {
                                    const next = selectedValues?.includes(id)
                                        ? selectedValues.filter((x) => x !== id)
                                        : [...(selectedValues ?? []), id];
                                    const agNext = next.length ? next : null;
                                    setSelectedValues(agNext);
                                    onModelChange(agNext);
                                }}
                            />
                            <span>{label}</span>
                        </div>
                    );
                })}
            </div>
            <Button size="sm" variant="secondary" onClick={onClick} className="mt-2">
                Готово
            </Button>
        </div>
    );
};
